import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import SvgInfo from './city/SvgInfo';

const InfoTooltip = (props: { className?: string; title?: string }) => {
  const {
    className,
    title = '数据来源依据于各平台公开薪酬数据，时间不同可能会产生波动，仅供参考。',
  } = props;

  return (
    <Tooltip
      title={title}
      disableTouchListener={true}
      placement="top"
      arrow={true}
      className={`hidden cursor-pointer ${className} tablet:inline-block`}
      PopperProps={{
        sx: {
          '.MuiTooltip-tooltip': {
            maxWidth: '220px',
            padding: '8px 16px',
            margin: 0,
            background: '#666',
            fontWeight: 400,
          },
        },
      }}
    >
      <i>
        <SvgInfo />
      </i>
    </Tooltip>
  );
};

export default InfoTooltip;
